import { Link } from 'react-router-dom';
import { categories } from '@/mocks/clCommunityData';

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  accent: { bg: 'bg-accent-100/80', text: 'text-accent-700', iconBg: 'bg-accent-500' },
  secondary: { bg: 'bg-secondary-100/80', text: 'text-secondary-700', iconBg: 'bg-secondary-500' },
  primary: { bg: 'bg-primary-100/80', text: 'text-primary-700', iconBg: 'bg-primary-500' },
};

export default function CategoryGrid() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 -mt-12 relative z-20">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {categories.map((cat) => {
          const colors = colorMap[cat.color];
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-200 group cursor-pointer hover:-translate-y-0.5"
            >
              <div className={`w-10 h-10 md:w-11 md:h-11 rounded-lg ${colors.iconBg} flex items-center justify-center mb-3`}>
                <i className={`${cat.icon} text-background-50 text-lg md:text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mb-2 line-clamp-1">{cat.description}</p>
              <span className={`text-xs font-medium ${colors.text} ${colors.bg} px-2 py-0.5 rounded-full`}>
                {cat.postCount.toLocaleString()} 帖
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}